<div class="h-100 position-relative">
  <form [formGroup]="selectCompanyNameForm">
    <finxone-input
      type="text"
      [label]="dataIn.attri.widgetProperties['inputLabel'] ?? 'Company name'"
      [value]="selectCompanyNameForm?.get('organisation_companyName')?.value ?? ''"
      formControlName="organisation_companyName"
    >
    </finxone-input>
  </form>
</div>
